import * as React from "react";
import { NumberFormatter } from "../core/numberFormatter";
import { Publication } from "../model/publication";

interface PublicationRankingItemProps {
    publication: Publication | null;
    onClick: (publication: Publication) => void;
}

export class PublicationRankingItem extends React.Component<PublicationRankingItemProps, {}> {
    constructor(props: PublicationRankingItemProps) {
        super(props);
        this.onClick = this.onClick.bind(this);
    }

    render(): JSX.Element {
        let imageURL = (this.props.publication && this.props.publication.imageURL) ? this.props.publication.imageURL : "";
        let likes = (this.props.publication && this.props.publication.likes) ? this.props.publication.likes : 0;
        return <div className="publication-item clickable" style={{backgroundImage: `url(${imageURL})`}}
            onClick={this.onClick}>
            <div className="like-block hboox">
                <div className="like-icon" style={{backgroundImage: `url("assets/app/images/like.png")`}}/>
                <div className="value">{NumberFormatter.getShortValueToDisplay(likes)}</div>
            </div>
        </div>;
    }

    private onClick() {
        if (this.props.publication) {
            this.props.onClick(this.props.publication);
        }
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--1!./src/app/ui/publicationRankingItem.tsx